<template>
    <el-card class="school-news-card">
        <el-row>
            <el-col class="news-title-top">
                <img src="../assets/images/zyb.png" :alt="title" class="zyb-img">
                {{ title }}
            </el-col>
        </el-row>

        <el-row class="news-box">
            <div v-if="newsStatus === '1'">
                <el-col v-for="index in 5" :key="index">
                    <ContentLoader primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="35" width="300">
                        <rect x="0" y="15" width="220" height="18" />
                    </ContentLoader>
                </el-col>
            </div>

            <div class="no-data-box" v-else-if="newsStatus === '2'">
                <img src="../assets/images/null.png" alt="没有数据">
                <p>暂无数据</p>
            </div>

            <el-row v-else class="news-list">
                <div
                    class="news-title"
                    v-for="item in newsList"
                    :key="item.id"
                    @click="handleClick(item)"
                >
                    {{ item.title }}
                </div>
            </el-row>
        </el-row>
    </el-card>
</template>

<script>
import { ContentLoader } from "vue-content-loader"
import { getSchoolDetailAPI, getSchoolNetReportAPI } from "@/api/postgraduate.js"

export default {
    name: "SchoolNewsCard",
    components: {
        ContentLoader
    },
    props: {
        title: {
            type: String,
            default: ""
        },
        schoolId: {
            type: [Number, String],
            default: ""
        },
        newsType: {
            type: Number,
            default: 0
        },
        mode: {
            type: String,
            default: "detail"
        },
        limit: {
            type: Number,
            default: 5
        }
    },
    data() {
        return {
            newsList: [],
            newsStatus: "1"
        }
    },
    watch: {
        schoolId: {
            immediate: true,
            handler() {
                this.getListHandler()
            }
        },
        newsType() {
            this.getListHandler()
        },
        mode() {
            this.getListHandler()
        }
    },
    methods: {
        getListHandler() {
            if (!this.schoolId) {
                this.newsList = []
                this.newsStatus = "2"
                return
            }

            this.newsStatus = "1"

            const request = this.mode === "netReport"
                ? getSchoolNetReportAPI(this.schoolId)
                : getSchoolDetailAPI(this.newsType, this.schoolId)

            request.then(res => {
              console.log(res, "res")
                const pageData = res.data || {}
                const list = Array.isArray(pageData.data) ? pageData.data : []

                this.newsList = list.slice(0, this.limit).map(item => {
                    return {
                        id: item.id,
                        title: this.mode === "netReport" ? item.notice_title : item.news_title,
                        raw: item
                    }
                })

                this.newsStatus = this.newsList.length ? "3" : "2"
            }).catch(() => {
                this.newsList = []
                this.newsStatus = "2"
            })
        },
        handleClick(item) {
            this.$emit("item-click", item.raw)
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables.scss";

.school-news-card {
    margin-bottom: 20px;
}

.news-title-top {
    text-align: left;
}

.zyb-img {
    width: 24px;
    height: 24px;
    position: relative;
    top: 4px;
}

.el-col {
    color: #2c2e33;
    font-size: 24px;
    font-weight: 600;
}

.news-box {
    border-top: 1px solid #f0f2f5;
    margin-top: 14px;
    // min-height: 180px;
    position: relative;

    .news-list {
        cursor: pointer;
        position: relative;

        .news-title {
            margin-top: 20px;
            cursor: pointer;
            @include gnowrap;
            text-align: left;
            font-size: 14px;
            color: #5e6166;
        }

        .news-title:hover {
            color: $common-color;
        }
    }
}

.no-data-box {
    padding: 36px 0 20px;
    text-align: center;

    img {
        width: 90px;
        height: 90px;
    }

    p {
        font-size: 14px;
        text-align: center;
        color: #abaeb3;
    }
}
</style>
